import $ from 'jquery';
import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import StateCodes from './stateCodes';

window.states = new StateCodes();

class LocalCheckoff {
    constructor() {
        this.mapTitle = '';
        this.lastFocusedElem = '';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('svg [class*="state-"]').each(i => {
            let curElem = $('svg [class*="state-"]')[i];
            let elem = $(`.local-checkoff-list-item[data-state="${$(curElem).attr('data-state')}"]`);

            if (!$(elem).length > 0) {
                $(curElem).addClass('disabled');
            }
        });

        $('svg [class*="state-"]').on('keypress', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');            
            }
        });

        $('.local-checkoff-close').on('keypress', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');            
            }
        });

        $(document).on('keydown', e => {
            if (e.key === 'Escape') {
                if (!$('.checkoff-map-info-card').hasClass('d-none')) {
                    $('.checkoff-map-info-card').addClass('d-none');
                    $('svg [class*="state-"]').removeClass('card-open');
                    $('svg [class*="state-"]').removeClass('active');
                    $('svg [class*="state-"]').trigger('blur');
                }
            
                this.disableModalFocusTrap();
            }
        });

        $(document).on('click', '.organization-grid-item', e => {
            $('svg [class*="state-"]').removeClass('card-open');
            $(e.currentTarget).addClass('active-focus');

            let stateList = $(`.local-checkoff-list-item[data-org="${$(e.currentTarget).attr('data-org')}"]`);
            
            for (let state of stateList) {
                $(`svg [data-state="${$(state).attr('data-state')}"]`).addClass('card-open');
            }
            this.updateCheckoffInfoCard(e.currentTarget);
        });

        $(document).on('click', 'path[class*="state-"]', e => {
            $('svg [class*="state-"]').removeClass('card-open');
            let elem = $(`.local-checkoff-list-item[data-state="${$(e.currentTarget).attr('data-state')}"]`);

            if ($(elem).length > 0) {
                $(e.currentTarget).addClass('card-open');
                this.updateCheckoffInfoCard(e.currentTarget, elem);
            }
        });

        $(document).on('click', 'polygon[class*="state-"]', e => {
            $('svg [class*="state-"]').removeClass('card-open');
            let elem = $(`.local-checkoff-list-item[data-state="${$(e.currentTarget).attr('data-state')}"]`);

            if ($(elem).length > 0) {
                $(e.currentTarget).addClass('card-open');
                this.updateCheckoffInfoCard(e.currentTarget, elem);
            }
        });

        $(document).on('click', '.local-checkoff-close', e => {
            $('.checkoff-map-info-card').addClass('d-none');
            $('svg [class*="state-"]').removeClass('card-open');

            this.disableModalFocusTrap();
        });

        $(document).on('click', '.hero-dropdown .accordion-title', e => {
            let currentDropdown = $(e.currentTarget).closest('.hero-dropdown');

            if ($(currentDropdown).hasClass('active')) {
                $(currentDropdown).removeClass('active');
                $('.hero-dropdown').removeClass('d-none');
            } else {
                $('.hero-dropdown').addClass('d-none');
                $(currentDropdown).removeClass('d-none');
                $(currentDropdown).addClass('active');
            }
        });

        $('path[class*="state-"]').on('mouseenter', e => {
            $(`path[data-id="${$(e.currentTarget).attr('data-id')}"]`).addClass('active');
        });
        
        $('path[class*="state-"]').on('mouseleave', e => {
            $(`path[data-id="${$(e.currentTarget).attr('data-id')}"]`).removeClass('active');
        });

        $('.organization-grid-item').on('mouseenter', e => {
            $(e.currentTarget).addClass('active');
            let stateList = $(`.local-checkoff-list-item[data-org="${$(e.currentTarget).attr('data-org')}"]`);
            
            for (let state of stateList) {
                $(`svg [data-state="${$(state).attr('data-state')}"]`).addClass('active');
            }
        });

        $('.organization-grid-item').on('mouseleave', e => {
            $(e.currentTarget).removeClass('active');
            $('svg [class*="state-"]').removeClass('active');
        });

        $('.organization-grid-item').on('focus', e => {
            $(e.currentTarget).addClass('active-focus');
            let stateList = $(`.local-checkoff-list-item[data-org="${$(e.currentTarget).attr('data-org')}"]`);
            
            for (let state of stateList) {
                $(`svg [data-state="${$(state).attr('data-state')}"]`).addClass('active');
            }
        });

        $('.organization-grid-item').on('blur', e => {
            $(e.currentTarget).removeClass('active-focus');

            let stateList = $(`.local-checkoff-list-item[data-org="${$(e.currentTarget).attr('data-org')}"]`);
            
            for (let state of stateList) {
                $(`svg [data-state="${$(state).attr('data-state')}"]`).removeClass('active');
                $(`svg [data-state="${$(state).attr('data-state')}"]`).removeClass('card-open');
                $(`svg [data-state="${$(state).attr('data-state')}"]`).trigger('blur');
            }
        });

        $('.organization-grid-item').on('keypress', e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(e.currentTarget).trigger('click');
            }
        });
    }

    updateCheckoffInfoCard(elem, elem2 = null) {
        $('.checkoff-map-info-card').removeClass('d-none');

        let info = {
            type: $(elem).attr('data-type'),
        };

        if (info.type === 'organization') {
            info = {
                type: $(elem).attr('data-type'),
                header: window.states.getStateName($(elem).attr('data-state')),
                org: $(elem).attr('data-org'),
                name: $(elem).attr('data-org'),
                url: $(elem).attr('data-url'),
                phone: $(elem).attr('data-phone'),
                address1: $(elem).attr('data-address-1'),
                address2: $(elem).attr('data-address-2'),
                district: $(elem).attr('data-dist'),
                state: $(elem).attr('data-state'),
                zip: $(elem).attr('data-zip'),
                logo: $(elem).attr('data-logo')
            };
        } else {
            info = {
                type: $(elem).attr('data-type'),
                header: window.states.getStateName($(elem).attr('data-id')),
                org: $(elem2).attr('data-org'),
                name: $(elem2).attr('data-org'),
                url: $(elem2).attr('data-url'),
                phone: $(elem2).attr('data-phone'),
                address1: $(elem2).attr('data-address-1'),
                address2: $(elem2).attr('data-address-2'),
                district: $(elem2).attr('data-dist'),
                state: $(elem2).attr('data-state'),
                zip: $(elem2).attr('data-zip'),
                logo: $(elem2).attr('data-logo')
            };
        }

        if (info.type === 'organization') {
            info.header = info.org;
            $('#checkoff-info-header').text(info.header);
            $('#checkoff-info-name').addClass('d-none');
        } else {
            $('#checkoff-info-name').removeClass('d-none');
            $('#checkoff-info-header').text(info.header);
            $('#checkoff-info-name').text(info.name);
        }
        

        $('#checkoff-info-url').attr('href', info.url);
        $('#checkoff-info-url').text(info.url.toLowerCase());
        $('#checkoff-info-cta').attr('href', info.url);

        $('#checkoff-info-phone').attr('href', `tel:${info.phone.replace(/[^0-9]/ig, '')}`);
        $('#checkoff-info-phone').text(info.phone);

        $('#checkoff-info-address-1').text(info.address1);

        if (info.address2 !== null || info.address2 !== '') {
            $('#checkoff-info-address-2').removeClass('d-none');
            $('#checkoff-info-address-2').text(info.address2);
        } else {
            $('#checkoff-info-address-2').addClass('d-none');
        }

        $('#checkoff-info-district').text(info.district);
        $('#checkoff-info-state').text(info.state);
        $('#checkoff-info-zip').text(info.zip);
        $('#checkoff-info-logo').attr('src', info.logo);
        $('#checkoff-info-logo').attr('data-image', info.logo);
        $('#checkoff-info-logo').attr('data-image-webp', info.logo);

        this.lastFocusedElem = elem;
        this.enableModalFocusTrap();
    }

    enableModalFocusTrap() {
        let elem = $('.checkoff-map-info-card')[0];
        let focusableElems = $(elem).find('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]), div[tabindex="0"]');
        let firstFocusableEl = focusableElems[1];  
        let lastFocusableEl = focusableElems[focusableElems.length - 1];

        $(document).on('keydown', elem, e => {
            this.tabEventListener(e, firstFocusableEl, lastFocusableEl);
        });

        $('.focus-anchor').trigger('focus');
    }

    disableModalFocusTrap() {
        let elem = $('.checkoff-map-info-card')[0];
        $(document).off('keydown', elem, this.tabEventListener);

        $(this.lastFocusedElem).trigger('focus');
        this.lastFocusedElem = '';
    }

    tabEventListener(e = null, first = null, last = null) {
        if (e.key === 'Tab') {
            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === first) {
                    last.focus();
                    e.preventDefault();
                } else {
                    // do nothing
                }
            } else if (document.activeElement === last) {
                first.focus();
                e.preventDefault();
            } else {
                // do nothing
            }
        }
    }
}

export default LocalCheckoff;

$(() => {
    const localCheckoff = new LocalCheckoff();
    localCheckoff.init();
});